import { create } from 'axios'
const baseUrl = process.env.REACT_APP_BASE_URL

const API = create({
  baseURL: baseUrl,
})

export const generateLink = (originLink, headers) =>
  API.post('/links/generate', originLink, headers)
export const getLinkById = (linkId, headers) =>
  API.get(`/links/${linkId}`, headers)
export const getLinks = (headers) => API.get('/links', headers)
export const deleteLink = (id) => API.delete(`/links/delete/${id}`)
